import reduce from "./reduce.js";
import { isAsyncIterable, isIterable } from "./_internal/utils.js";

function sync(sep, iterable) {
  return reduce(function (a, b) {
    return "".concat(a).concat(sep).concat(b);
  }, iterable);
}

function async(sep, iterable) {
  return reduce(function (a, b) {
    return "".concat(a).concat(sep).concat(b);
  }, iterable);
}

function join(sep, iterable) {
  if (iterable === undefined) {
    return function (iterable) {
      return join(sep, iterable);
    };
  }

  if (Array.isArray(iterable) && iterable.length === 0) return "";

  if (isIterable(iterable)) {
    return sync(sep, iterable);
  }

  if (isAsyncIterable(iterable)) {
    return async(sep, iterable);
  }

  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}

export default join;